import * as googleAnalytics from './insights/googleAnalytics'

export const create = () => {
  googleAnalytics.create()
}

export const pageview = (pathname = '/', search = '') => {
  googleAnalytics.pageview(pathname, search)
}

export const setUser = userData => {
  googleAnalytics.setUser(userData)
}

export const setRealm = realm => {
  googleAnalytics.setRealm(realm)
}

export const data = (custom = {}) => {
  googleAnalytics.data(custom)
}

export const event = (eventData = {}) => {
  googleAnalytics.event(eventData)
}

export const logException = (action = {}) => {
  googleAnalytics.logException(action)
}

export const trackSidebarNavigation = ({ label }) => {
  googleAnalytics.event({
    category: 'menu-sidebar',
    action: 'navigation',
    label
  })
}
